import React from 'react';
import { Render } from '../../platformui';
import classNames from 'classnames';
import SemanticHeader from '../Chapter/semantic-header';
import useWindowLocationHref from '../Hooks/useWindowLocation';

/**
 * @typedef LinkProps
 * @property {string | null} url
 * @property {string | null} [linkText]
 */

/**
 *
 * @param {LinkProps} props
 * @returns
 */
const Link = ({ url = null, linkText = null }) => {
  const href = useWindowLocationHref();
  if (url === null) {
    return null;
  }

  return (
    <a
      data-event-category={href || 'novalue'}
      data-event-action={linkText}
      data-event-name="Länk i filmblocksbehållare"
      className="c-video-container__textarea__link"
      href={url}
    >
      <span data-event-include>{linkText ? linkText : 'Till artikeln'}</span>
    </a>
  );
};

/**
 * @typedef VideoContainerProps
 * @property {string} [className]
 * @property {object} CurrentPageProps
 * @property {string} Description
 * @property {boolean} [DisableVideoBlockText]
 * @property {string | null} [Heading]
 * @property {unknown} [isH3]
 * @property {boolean} [isMemberOfChapterContainer]
 * @property {string | null} [LinkText]
 * @property {object | null} MainContent
 * @property {string | null} [Url]
 */

/**
 *
 * @param {VideoContainerProps} props
 * @returns
 */
const VideoContainer = (props) => {
  const {
    className = null,
    CurrentPageProps = {},
    Description,
    Heading = null,
    isMemberOfChapterContainer = false,
    LinkText = null,
    MainContent = null,
    Url = null,
  } = props;

  const isStartPage = CurrentPageProps.PageTypeName === 'StartPage';
  const isCollectionPage = CurrentPageProps.PageTypeName === 'CollectionPage';
  const isStandaloneCollectionPage =
    isCollectionPage && !isMemberOfChapterContainer;

  const firstVideo = MainContent?.[0] || null;
  const isStandingVideo = firstVideo?.IsStandingVideo || false;

  const containerClasses = classNames(
    {
      'c-video-container': true,
      'c-video-container--standing': isStandingVideo,
    },
    className
  );

  const videContainerElement = (
    <div className={containerClasses}>
      <div className="c-video-container__block">
        {MainContent && (
          <Render.Block
            blocks={MainContent}
            currentPageProps={{
              ...CurrentPageProps,
              DisableVideoBlockText: true,
            }}
          >
            <Render.BlockTypeRenderer Blocks={props.Blocks} />
          </Render.Block>
        )}
        <div className="c-video-container__textarea">
          <SemanticHeader
            isH3={props.isH3 || false}
            className="c-video-container__textarea__heading"
          >
            {Heading ? Heading : firstVideo?.Heading}
          </SemanticHeader>
          <p className="c-video-container__textarea__description">
            {Description}
          </p>
          <Link url={Url} linkText={LinkText} />
        </div>
      </div>
    </div>
  );

  if (isStartPage || isStandaloneCollectionPage) {
    const wrapperClasses = classNames({
      'c-video-container-wrapper': true,
      'c-video-container-wrapper--start-page': isStartPage,
      'c-video-container-wrapper--collection-page-standalone':
        isStandaloneCollectionPage,
    });

    return (
      <section className="c-section">
        <div className={wrapperClasses}>{videContainerElement}</div>
      </section>
    );
  }

  return videContainerElement;
};

export default VideoContainer;
